<template>
  <div>
    <el-form
      label-position="top"
      label-width="150px"
      ref="nuggetForm"
      :model="localNugget"
      :rules="rules"
      @submit.native.prevent
    >
      <el-form-item :label="`${localNugget.title}`" prop="value">
        <template v-if="localNugget.field === 'gender'">
          <el-select v-model="localNugget.value" placeholder="Select Gender">
            <el-option label="Male" value="Male"></el-option>
            <el-option label="Female" value="Female"></el-option>
            <el-option label="Other" value="Other"></el-option>
          </el-select>
        </template>
        <template v-else-if="localNugget.field === 'age_range'">
          <el-select v-model="localNugget.value" placeholder="Select Age">
            <el-option label="Under 18" value="Under 18"></el-option>
            <el-option label="18-24" value="18-24"></el-option>
            <el-option label="25-34" value="25-34"></el-option>
            <el-option label="35-49" value="35-49"></el-option>
            <el-option label="50-64" value="50-64"></el-option>
            <el-option label="65+" value="65+"></el-option>
          </el-select>
        </template>
        <template v-else>
          <el-input v-model="localNugget.value" :placeholder="`Enter new ${localNugget.title}`"></el-input>
        </template>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer clearfix">
      <div class="pull-right">
        <el-button
          type="danger"
          size="small"
          class="ibox-tool-btn"
          @click="$emit('close')"
          plain
        >Cancel</el-button>
        <el-button
          type="primary"
          size="small"
          class="ibox-tool-btn"
          :loading="savingNugget"
          :disabled="!isValueChanged || savingNugget"
          @click="handleEditFormSave"
          plain
        >Save</el-button>
      </div>
    </span>
  </div>
</template>

<script>
export default {
  name: 'EditNuggetDialog',
  data: () => ({
    localNugget: {},
    originalValue: null,
    savingNugget: false,
    rules: {
      value: [{ required: true, message: 'Please input a value' }],
    },
  }),
  props: {
    nugget: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {
    this.localNugget = { ...this.nugget };
    this.originalValue = this.localNugget.value;
  },
  computed: {
    isValueChanged() {
      return this.localNugget.value !== this.originalValue;
    },
  },
  methods: {
    handleEditFormSave() {
      this.$refs.nuggetForm.validate(valid => {
        if (valid) return this.saveNugget();
        return false;
      });
    },
    saveNugget() {
      this.$emit('saveNugget', this.localNugget);
    },
  },
};
</script>


// WEBPACK FOOTER //
// EditNuggetDialog.vue?1ad77d13